import React from 'react';
import {
    SIGNIN_ROUTE,
    HOME_ROUTE,
    MY_STUDENTS_ROUTE,
    SETTINGS_ROUTE,
    EDIT_GROUP_ROUTE,
    ADD_GROUP_ROUTE,
    HISTORY_ROUTE,
    LESSONS_ROUTE,
    ADD_LESSON_ROUTE,
    LESSON_ROUTE,
    MY_STUDENT_ROUTE,
    EDIT_LESSON_ROUTE,
    PAYMENTS_ROUTE,
    PAY_ROUTE,
    SIGNUP_ROUTE,
    ACCESS_ROUTE,
    TEACHERS_ROUTE,
    ADD_TEACHER_ROUTE,
    STUDENTS_ROUTE,
    EDIT_STUDENT_ROUTE,
    STUDENT_ROUTE,
    GROUPS_ROUTE,
    EDIT_TEACHER_ROUTE,
    BIRTHDAYS_ROUTE,
    HOMEWORKS_ROUTE,
    WAGES_ROUTE,
    ADD_PREMIUM_ROUTE,
    ANALYTICS_ROUTE,
    ADD_PERCENT_ROUTE,
    COPY_LESSON_ROUTE,
    STUDENT,
    TEACHER,
    ADMIN,
    EDIT_OLD_LESSON_ROUTE,
    BONUS_RULES_ROUTE,
    ADD_BONUS_RULE_ROUTE, EDIT_BONUS_RULE_ROUTE
} from "./utils";
import Signin from "./page/authPage";
import Signup from './page/registerPage';
import HomePage from './page/homePage';
import MyStudentsPage from './page/myStudentsPage';
import SettingsPage from './page/settingsPage';
import EditGroupPage from './page/editGroupePage';
import AddGroupPage from './page/addGroupePage';
import HistoryPage from './page/historyPage';
import LessonsPage from './page/lessonsPage';
import AddLessonPage from './page/addLessonPage';
import LessonPage from './page/lessonPage';
import MyStudentPage from './page/myStudentPage';
import EditLessonPage from './page/editLessonPage';
import EditOldLessonPage from './page/editOldLessonPage';
import PaymentsPage from './page/paymentsPage';
import PaymentPage from './page/paymentPage';
import AccessPage from './page/accessPage'
import TeachersPage from "./page/teachersPage";
import AddTeacherPage from "./page/addTeacherPage";
import StudentsPage from "./page/studentsPage";
import EditStudentPage from "./page/editStudentPage";
import StudentPage from "./page/studentPage";
import GroupsPage from "./page/groupsPage";
import EditTeacherPage from "./page/editTeacherPage";
import BirthdaysPage from "./page/birthdaysPage";
import HomeworksPage from "./page/homeworksPage";
import WagesPage from "./page/wagesPage";
import AddPremiumPage from "./page/addPremiumPage";
import AnalyticsPage from "./page/analyticsPage";
import AddPercentPage from "./page/addPercentPage";
import CopyLessonPage from "./page/CopyLessonPage";
import BonusRulesPage from "./page/bonusRulesPage";
import AddBonusRulePage from "./page/addBonusRulePage";
import EditBonusRulePage from "./page/editBonusRulePage";

export const routes = [
    {
        path: SIGNIN_ROUTE,
        Component: <Signin/>,
        roles: []
    },
    {
        path: SIGNUP_ROUTE,
        Component: <Signup/>,
        roles: []
    },
    {
        path: HOME_ROUTE,
        Component: <HomePage/>,
        roles: [TEACHER, STUDENT]
    },
    {
        path: MY_STUDENTS_ROUTE + '/:id',
        Component: <MyStudentsPage/>,
        roles: [ADMIN, TEACHER]
    },
    {
        path: SETTINGS_ROUTE,
        Component: <SettingsPage/>,
        roles: []
    },
    {
        path: EDIT_GROUP_ROUTE + '/:id',
        Component: <EditGroupPage/>,
        roles: [ADMIN, TEACHER]
    },
    {
        path: ADD_GROUP_ROUTE,
        Component: <AddGroupPage/>,
        roles: [ADMIN, TEACHER]
    },
    {
        path: HISTORY_ROUTE + '/:id',
        Component: <HistoryPage/>,
        roles: [STUDENT]
    },
    {
        path: LESSONS_ROUTE + '/:id',
        Component: <LessonsPage/>,
        roles: [ADMIN, TEACHER]
    },
    {
        path: ADD_LESSON_ROUTE + '/:id',
        Component: <AddLessonPage/>,
        roles: [ADMIN, TEACHER]
    },
    {
        path: LESSON_ROUTE + '/:id/:number',
        Component: <LessonPage/>,
        roles: [ADMIN, TEACHER]
    },
    {
        path: MY_STUDENT_ROUTE + '/:groupId/:id',
        Component: <MyStudentPage/>,
        roles: [ADMIN, TEACHER]
    },
    {
        path: EDIT_LESSON_ROUTE + '/:id/:number',
        Component: <EditLessonPage/>,
        roles: [ADMIN, TEACHER]
    },
    {
        path: EDIT_OLD_LESSON_ROUTE + '/:id/:number',
        Component: <EditOldLessonPage/>,
        roles: [ADMIN, TEACHER]
    },
    {
        path: COPY_LESSON_ROUTE + '/:id/:number',
        Component: <CopyLessonPage/>,
        roles: [ADMIN, TEACHER]
    },
    {
        path: HOMEWORKS_ROUTE + '/:id',
        Component: <HomeworksPage/>,
        roles: [ADMIN, TEACHER]
    },
    {
        path: PAYMENTS_ROUTE + '/:id',
        Component: <PaymentsPage/>,
        roles: [STUDENT]
    },
    {
        path: PAY_ROUTE + '/:id',
        Component: <PaymentPage/>,
        roles: [STUDENT]
    },
    {
        path: ACCESS_ROUTE + '/:id',
        Component: <AccessPage/>,
        roles: []
    },
    {
        path: TEACHERS_ROUTE,
        Component: <TeachersPage/>,
        roles: [ADMIN]
    },
    {
        path: ADD_TEACHER_ROUTE,
        Component: <AddTeacherPage/>,
        roles: [ADMIN]
    },
    {
        path: STUDENTS_ROUTE,
        Component: <StudentsPage/>,
        roles: [ADMIN]
    },
    {
        path: STUDENT_ROUTE + '/:id',
        Component: <StudentPage/>,
        roles: [ADMIN]
    },
    {
        path: EDIT_STUDENT_ROUTE + '/:id',
        Component: <EditStudentPage/>,
        roles: [ADMIN]
    },
    {
        path: EDIT_TEACHER_ROUTE + '/:id',
        Component: <EditTeacherPage/>,
        roles: [ADMIN]
    },
    {
        path: GROUPS_ROUTE,
        Component: <GroupsPage/>,
        roles: [ADMIN]
    },
    {
        path: BIRTHDAYS_ROUTE,
        Component: <BirthdaysPage/>,
        roles: [ADMIN]
    },
    {
        path: WAGES_ROUTE,
        Component: <WagesPage/>,
        roles: [TEACHER]
    },
    {
        path: ADD_PREMIUM_ROUTE,
        Component: <AddPremiumPage/>,
        roles: [ADMIN]
    },
    {
        path: ANALYTICS_ROUTE,
        Component: <AnalyticsPage/>,
        roles: [ADMIN]
    },
    {
        path: ADD_PERCENT_ROUTE,
        Component: <AddPercentPage/>,
        roles: [ADMIN]
    },
    {
        path: BONUS_RULES_ROUTE,
        Component: <BonusRulesPage/>,
        roles: [ADMIN]
    },
    {
        path: ADD_BONUS_RULE_ROUTE,
        Component: <AddBonusRulePage/>,
        roles: [ADMIN]
    },
    {
        path: EDIT_BONUS_RULE_ROUTE + '/:id',
        Component: <EditBonusRulePage/>,
        roles: [ADMIN]
    },
]